import { render, staticRenderFns } from "./modal-add-credits.vue?vue&type=template&id=cf36b5fa&scoped=true"
import script from "./modal-add-credits.vue?vue&type=script&lang=js"
export * from "./modal-add-credits.vue?vue&type=script&lang=js"
import style0 from "./modal-add-credits.vue?vue&type=style&index=0&id=cf36b5fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf36b5fa",
  null
  
)

export default component.exports